<script>

    import Icon from '../Icon.svelte';
    import arrowRightIcon from '../../assets/icons/arrow-right.svg?raw';

    const { treatment, onclick } = $props();

</script>


<button type="button" onclick={() => onclick(treatment.id)}>
    <h4>{treatment.name}</h4>
    
    <p class='description'>
        {treatment.description}
    </p>

    {#if treatment.price && treatment.price.value > 0 && treatment.price.visible}
        <p class='price'>
            {treatment.price.name}
        </p>
    {/if}

    <Icon data={arrowRightIcon} />
</button>


<style>

    button {
        display: grid;
        width: 100%;

        grid-template-columns: 1fr min-content min-content;
        grid-template-rows: min-content 1fr;

        background: var(--box-color);
        color: var(--text-color);

        border-radius: 0.5rem;
        border: none;
        padding: 1.2rem;
        gap: 0.4rem 0.5rem;

        cursor: pointer;
    }

    button:hover {
        background: var(--box-hover-color);
    }

    button:has(+ :global(button)) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    button :global(+ button) {
        border-top: 2px solid var(--background-color);
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    button h4 {
        grid-column: 1;
        grid-row: 1;
        margin: 0;

        overflow-x: hidden;
        text-overflow: ellipsis;

        font-size: 1rem;
        font-weight: 600;
        text-align: left;
    }

    button:has(.description:empty) h4 {
        grid-row: 1 / span 2;
        align-self: center;
    }

    button .description {
        grid-column: 1;
        grid-row: 2;
        margin: 0;

        font-size: 0.85rem;
        text-align: left;
    }
    
    button .description:empty {
        display: none;
    }

    button .price {
        grid-column: 2;
        grid-row: 1 / span 2;
        align-self: center;
        margin: 0;

        font-family: var(--theme-alt-font-family);
        font-size: 1.6rem;
        margin-left: 1rem;
    }

    button :global(svg) {
        grid-column: 3;
        grid-row: 1 / span 2;
        align-self: center;

        width: 1.6rem;
        height: 1.6rem;
        margin-left: 0.5rem;
    }

    @media (max-width: 480px) {
        button .price {
            font-size: 1.2rem;
        }

        button :global(svg) {
            width: 1.2rem;
            height: 1.2rem;
        }
    }

    @media (max-width: 384px) {
        button {
            grid-template-columns: 1fr min-content;
            gap: 0.4rem 0.8rem;
        }

        button .price {
            grid-column: 2;
            grid-row: 1 / span 2;
            align-self: center;
            margin-left: 0;
            margin-top: -1.5rem;
            font-size: 1.2rem;
        }

        button :global(svg) {
            grid-column: 2;
            grid-row: 1 / span 2;
            align-self: center;
            justify-self: end;
            margin-left: 0;

            width: 1.2rem;
            height: 1.2rem;
        }

        button:has(.price) :global(svg) {
            margin-top: 1.5rem;
        }
    }

</style>